export enum PanDrawerUpgradeCost {
    NONE = 0,
    HIGH_SIDES = 16.5,
    FROSTED_SIDES = 27.5
}
